import {ISchemaRoute} from '../../schema-static';

export const COGNITO_PUBLIC_SCHEMA_ROUTE: ISchemaRoute = {
    singularRoute: 'cognitoPublic',
    pluralRoute: 'cognitoPublics',
};
